import COM from './Video'

export default COM
